import { render, staticRenderFns } from "./BannerPlaceholder.vue?vue&type=template&id=0794fda0&"
import script from "./BannerPlaceholder.vue?vue&type=script&lang=js&"
export * from "./BannerPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports